import { mutatorAction } from 'satcheljs';
import { mobileDeviceFullStore } from '../store/store';
import CASMailbox from 'owa-service/lib/contract/CASMailbox';
import MobileDeviceStatistics from 'owa-service/lib/contract/MobileDeviceStatistics';
import { getDevicesFromStatistics } from '../utils/getDevicesFromStatistics';

export let initMobileDeviceFullStore = mutatorAction(
    'initMobileDeviceFullStore',
    (deviceStatistics: MobileDeviceStatistics[], casMailbox: CASMailbox) => {
        let store = mobileDeviceFullStore();
        store.devices = getDevicesFromStatistics(deviceStatistics);
        store.deviceStatistics = deviceStatistics;
        store.casMailbox = casMailbox;
        store.isLoggingEnabled = casMailbox.ActiveSyncDebugLogging;
        store.notSendReadReceipt = casMailbox.ActiveSyncSuppressReadReceipt;
        store.selected = -1;
        store.isLoggingOpen = false;
        store.isDetailsOpen = false;
        store.isLoggingEnabledDirty = false;
        store.isNotSendReadReceiptDirty = false;
        store.isDevicesDirty = false;
    }
);
